// One partner: profile and features, team, grants (tkt-backend docs/PARTNER-PORTAL.md). The page reads
// its own record by id, so a shared link opens it cold. Where there is no partner portal
// (lib/accessGating partnersEnabled: MoMo) the address goes to the dashboard.
import React from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { partnersEnabled } from '../lib/accessGating';
import { PartnerDetailPage } from '../modules/partners/PartnerDetailPage';

export const Route = createFileRoute('/partners/$id')({
  beforeLoad: () => {
    if (!partnersEnabled()) throw redirect({ to: '/', replace: true });
  },
  component: function PartnerRoute() {
    const { id } = Route.useParams();
    return <PartnerDetailPage partnerId={id} />;
  },
});
